export default __webpack_public_path__ + "static/Entenda0122-0656542395308cde4e5edfa78917de6e.jpg";